import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { Button } from '@storaensods/se-design-system';

const Header = styled.header`
  display: flex;
  width: 100%;
  height: 50px;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px;
`;

const SignOut = styled.div`
  padding: 5px;
`;
const User = styled.div`
  margin-left: 5px;
  display: flex;
  align-items: center;
`;
const UserName = styled.span`
  padding: 5px;
`;

const Logo = styled.img`
  max-height: 36px;
`;

const AvatarHeader = ({ t, user, signOut }) => (
  <Header>
    <User>
      <Logo src="https://cdn.selflystore.com/images-general/logos/selfly-logo-small.svg" />
      <UserName>{user.profile.name}</UserName>
    </User>
    <SignOut>
      <Button type="secondary" size="sm" onClick={signOut}>
        {t('signout')}
      </Button>
    </SignOut>
  </Header>
);

export default translate('common')(AvatarHeader);
